import * as THREE from "three";
import React, { useRef, useEffect, memo } from "react";
import { useFrame, useThree } from "@react-three/fiber";
import Control from '../store/control';
import Param from '../store/param';

const MProjectCurve = memo(({ color, axisMove, axisShow, initialPosition=null, fix=false, isCenter=false, isCenterX=false, isCenterZ=false, linewidth=1, callback1, callback2}) => {
  const origin          = Control.Get('origin');
  const setControl      = Control.Get('setControl');
  const click           = Control.Get('click');
  const projectPoints   = Control.Get('projectPoints');

  const ref  = useRef();

  useFrame(() => {
    ref.current.material.linewidth = linewidth;
  });

  // This if for initial line position if param.json is loaded
  useEffect(() => {
    if (initialPosition) {
      const maxY = 500
      const points = [new THREE.Vector3(initialPosition, -maxY, 0), new THREE.Vector3(initialPosition, maxY, 0)]
      ref.current.geometry.setFromPoints(points)
    }
  }, []);

  useEffect(() => {
    if((click != null) && (fix==false) ){
      if(axisMove == "x"){ // For Center X
        //setControl(s => {s.origin = new THREE.Vector3(click.x, 0, 0)});
        setControl(s => {s.origin = new THREE.Vector3(click.x, origin.y, origin.z)});
        if (callback2) {
          callback2(click.x);
        }
        console.log('set origin.x = ', click.x);
      }
      else if(axisMove == "y"){ // For MPT
        setControl(s => {s.origin = new THREE.Vector3(origin.x, click.y, origin.z)});
        console.log('set origin.y = ', click.y);
      }
      else if(axisMove == "z"){ // For Center Y
        setControl(s => {s.origin = new THREE.Vector3(origin.x, origin.y, click.z)});
        console.log('set origin.z = ', click.z);
      }
      setControl(s => {s.click = null});

      if (isCenter) {
        setControl(s => {s.toModifyYheight = true});
      }

      if (isCenterX) {
        setControl(s => {s.toModifyX = true});
      }

      if (isCenterZ) {
        setControl(s => {s.toModifyZ = true});
      }
    }
  }, [click]);

  useEffect(() => {
    if (projectPoints) {
      // get bottom value for stump length
      var stumpLength = 0;
      for (let i = 0; i < projectPoints.length; i++) {
        if (projectPoints[i].y < stumpLength) {
          stumpLength = projectPoints[i].y
        }
      }
      stumpLength *= -1;

      ref.current.geometry.setFromPoints(projectPoints);
      if (callback1) {
        callback1(stumpLength);
      }
    }
  }, [projectPoints]);
  
  return (
    <line ref={ref} renderOrder={1}>
      <bufferGeometry attach="geometry" />
      <lineBasicMaterial attach="material" color={color} depthTest={false} />
    </line>
  );
});

export default MProjectCurve ;
